<template>
	<v-dialog v-model="tagDialogVisible" width="700">
    <customDialog>
      <template v-slot:title>
        {{t('tag')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="tagDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-col class="ma-0 pa-0" cols="12">
					<v-col class="ma-0 pa-0" cols="12" style="height:300px;">
						<v-row class="ma-0 pa-0 pt-2 pb-7" align="start">
							<v-col class="ma-0 pa-0" cols="auto"
								v-for="item in tagList" :key="item.label">
								<template v-if="item.selected">
									<v-btn width="auto" height="auto" class="ma-0 pa-2 pt-1 pb-1 pl-3 pr-3 mr-3 mb-4 text-none" 
										id="blue_btn" elevation="0" style="border-radius:25px;font-size:0.8rem;"
										@click="tagClick(item)">
										{{ item.label.length < 45 ? item.label : item.label.substring(0, 42) + "..." }}	
									</v-btn>
								</template>
								<template v-else>
									<v-btn width="auto" height="auto" class="ma-0 pa-2 pt-1 pb-1 pl-3 pr-3 mr-3 mb-4 text-none" 
										id="grey_btn" elevation="0" style="border-radius:25px;font-size:0.8rem;"
										@click="tagClick(item)">
										{{ item.label.length < 45 ? item.label : item.label.substring(0, 42) + "..." }}	
									</v-btn>
								</template>
							</v-col>
						</v-row>
					</v-col>
          <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
						<v-btn class="ma-0 pa-0" id="grey_btn" @click="tagReset"
					 		width="8rem" height="2rem">{{t('reset')}}</v-btn>
           	<v-btn class="ma-0 pa-0 ml-2" id="grey_btn" @click="tagDialogVisible = false"
					 		width="8rem" height="2rem">{{t('cancel')}}</v-btn>
           	<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" @click="confirm"
					 		width="8rem" height="2rem">{{t('confirm')}}</v-btn>
          </v-row>
        </v-col>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean
	},
	components: {
		customDialog
	},
	mixins: [mixin.common],
	data: () => ({
		tagDialogVisible: false,
		tagList: [],
		selectedTagList: [],
	}),
	watch: {
		dialogVisible: function(item) {
			this.tagDialogVisible = item;
		},
		tagDialogVisible: function(item) {
			this.$emit('tagVisible', item);
			if(item == true) {
				const searchCondition = this.$store.getters.getSearchCondition;
				let getTagList = searchCondition.tagNames == '' 
					? []
					: searchCondition.tagNames.split(',');
				if(getTagList.length != 0) {
					this.selectedTagList = getTagList.map(item => {
						return { label: item, selected: true }
					});
					setTimeout(() => {
						this.tagList.forEach((tag, index) => {
							getTagList.forEach((item) => {
								if(tag.label == item) {
									this.tagList[index].selected = true;
								}
							})
						})
					}, 100);
				}
			}
		},
	},
	mounted() {
    this.getAllTagList();
  },
	methods: {
		async tagClick(tag) {
			let getIndex = await this.tagList.findIndex((element, index, arr) => element.label === tag.label);
			if(this.tagList[getIndex].selected == false) {
				this.selectedTagList.push(tag);
				this.tagList[getIndex].selected = !this.tagList[getIndex].selected;
			} else {
				this.tagList[getIndex].selected = !this.tagList[getIndex].selected;
				if(this.selectedTagList.length != 0) {
					let selectedGetIndex = await this.selectedTagList.findIndex((element, index, arr) => element.label === tag.label);
					this.selectedTagList.splice(selectedGetIndex, 1);
				}
			}
			console.log(this.selectedTagList);
		},
		tagReset() {
			this.tagList.forEach((item) => {
				item.selected = false;
			});
			this.selectedTagList = [];
		},
		async getAllTagList() {
			let params = {};
			await this.networkController.getAllTagList(params)
			.then(async (res) => {
				console.log('%cAll Tag List\n', "color:#008DD0;", res.data);
				// this.tagList = res.data.cameraTagNames == undefined ? [] : res.data.cameraTagNames;
				this.tagList = res.data.cameraTagNames.map(item => {
					return { label: item, selected: false }
				});
			}).catch(error => { });
		},
		makeTagStr() {
			let tagStr = '';
			this.selectedTagList.forEach((item, index) => {
				if(index == 0) {
					tagStr = item.label;
				} else {
					tagStr = tagStr + ',' + item.label;
				}
			});
			return tagStr;
		},
		confirm() {
			const tagNames = this.makeTagStr();
			setTimeout(() => {
				this.$emit('tagNames', tagNames);
				this.tagDialogVisible = false;
			}, 100);
		},
	}
}
</script>

<style lang="scss" scoped>
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
}
</style>